import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Form } from 'react-form';
import { find } from 'lodash';

import { Input, Select, PlayerSearch } from '../../Form';
import { required } from '../../../utils/validation';
import Popup from '../../Popup';
import { getPlayerName } from '../../../utils';
import styles from './registerPlayerToEventPopUp.scss';
import { addPlayerByOrganizer } from '../../../actions/event-actions';

const _ = { find };

const RegisterPlayerToEventPopUp = (props) => {
    const { onCloseClick, divisions, isDemoEvent, registeredPlayers, eventId, onPlayerAdded } = props;
    const [step, setStep] = useState('select_player');
    const [submitting, setSubmitting] = useState(false);
    const [data, setData] = useState(null);
    const [playerName, setPlayerName] = useState();
    const [playerGender, setPlayerGender] = useState();
    const dispatch = useDispatch();

    const submitData = async (values) => {
        const res = await dispatch(addPlayerByOrganizer(eventId, values));
        setSubmitting(false);
        setStep(res ? 'succesfully_added' : 'select_division');
        setData(res);
    };

    const defaultValues = {
        playerId: null,
        divisionId: null,
    };

    return (
        <Popup
            className={`popup-md`}
            popUpClassName={`${styles.addUpdatePlayerOnRosterPopUp}`}
            popUpContentWrapperClassName={`overflow-unset`}
            onCloseClick={onCloseClick}
            config={{
                noPadding: true,
                fullScreen: false,
                topGradient: false,
                scrollable: false,
            }}
        >
            {step !== 'succesfully_added' && (
                <>
                    <div className={`${styles.section} pt0 pb16`}>
                        <h4>
                            {playerName ? `Add ${playerName} to event` : `Add player to event`}
                        </h4>
                    </div>
                    <div className={`${styles.section} pt0 pb24`}>
                        <Form
                            onSubmit={(values) => {
                                if (step === 'select_player') {
                                    setStep('select_division');
                                } else {
                                    setSubmitting(true);
                                    submitData(values);
                                }
                            }}
                            id="registerPlayerForm"
                            defaultValues={defaultValues}
                        >
                            {({ submitForm, setValue, values }) => {
                                const divisionOptions = [];
                                const selectedRegisteredPlayer = _.find(registeredPlayers, { id: values.playerId });
                                divisions.forEach((division) => {
                                    const isDivisionGenderMatched = division.gender.description === 'Co-ed' || division.gender.description === playerGender;
                                    const isAlreadyRegisteredForDivision = selectedRegisteredPlayer ? _.find(selectedRegisteredPlayer.registeredDivisions, { divisionId: division.id }) !== null : false;
                                    const isSinglesDivision = division.divisionFormatType.value === 'singles';
                                    if (isSinglesDivision && isDivisionGenderMatched && !isAlreadyRegisteredForDivision) {
                                        divisionOptions.push({
                                            id: division.id,
                                            label: division.name,
                                            value: division.name,
                                        });
                                    }
                                });
                                return (
                                    <form onSubmit={submitForm} id="registerPlayerByOrganizerForm">
                                        <Input id="playerId" field={'playerId'} type="hidden" />
                                        {step === 'select_player' && (
                                            <div className="row mb32">
                                                <div className="col-12">
                                                    <div className={`form-group form-group-xl description`}>
                                                        <label htmlFor={`playerId`}>
                                                            Select a player from all members
                                                        </label>
                                                        <PlayerSearch
                                                            className="form-control"
                                                            placeholder="Search players"
                                                            showInvitePlayer={false}
                                                            showDemoPlayers={isDemoEvent}
                                                            handlePlayerSelect={(player) => {
                                                                setValue('playerId', player.id);
                                                                setPlayerName(getPlayerName(player.firstName, player.lastName));
                                                                setPlayerGender(player.gender);
                                                                setStep('select_division');
                                                            }}
                                                            clearAfterSelect={true}
                                                            searchMembersOnly={true}
                                                            excludeProPlayers={true}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                        {step === 'select_division' && (
                                            <React.Fragment>
                                                <div className="row mb32">
                                                    <div className="col-12">
                                                        <Select
                                                            key={`divisionId`}
                                                            id={`divisionId`}
                                                            label="Division"
                                                            description="Select the primary singles division for registration. You can add/move player to any singles or doubles draws after registration."
                                                            field={'divisionId'}
                                                            options={divisionOptions}
                                                            validate={required}
                                                            emptyOption="Select division..."
                                                        />
                                                    </div>
                                                </div>
                                            </React.Fragment>
                                        )}
                                        <hr />
                                        <div className="row">
                                            <div className="col-12 col-md-6 mb16">
                                                <button
                                                    onClick={onCloseClick}
                                                    type="button"
                                                    className="btn btn-default btn-xl text-uppercase btn-block"
                                                    disabled={submitting}
                                                >
                                                    Cancel
                                                </button>
                                            </div>
                                            <div className="col-12 col-md-6">
                                                <button
                                                    type="submit"
                                                    className="btn btn-primary btn-xl text-uppercase btn-block"
                                                    disabled={(step === 'select_player' && !values.playerId) || submitting}
                                                >
                                                    {step === 'select_player' ? 'Next' : submitting ? `Adding player` : `Add player`}
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                );
                            }}
                        </Form>
                    </div>
                </>
            )}
            {step === 'succesfully_added' && (
                <>
                    <div className={`${styles.section} pt0 pb24`}>
                        <h4>
                            {playerName ? `Successfully added ${playerName} to event` : `Successfully added player to event`}
                        </h4>
                    </div>
                    <div className={`${styles.section} pt0 pb24 pt24`}>
                        <div className="row">
                            <div className="col-12 offset-md-3 col-md-6">
                                <button
                                    className="btn btn-primary btn-xl text-uppercase btn-block"
                                    onClick={() => {
                                        onPlayerAdded(data);
                                    }}
                                    type="button"
                                >
                                    OK
                                </button>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </Popup>
    );
};

export default RegisterPlayerToEventPopUp;
